import React from 'react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { FormattedMessage } from 'react-intl';

import { Button } from '@components/Base/Button';
import SidePanel from '@components/SidePanel';

import messages from './messages';

const COLON = ':';

interface ExamDetailsProps {
  openPanel: boolean;
  closePanel: () => void;
  saveExamDetails: () => void;
}

const ExamDetails = (props: ExamDetailsProps) => {
  const { openPanel, closePanel, saveExamDetails } = props;

  return (
    <SidePanel show={openPanel} onClose={closePanel} containerPadding="p-0" allowCustomHeader>
      <div className="flex flex-col flex-1">
        <div className="sticky top-0">
          <div className="flex p-5 bg-white border-b border-gray-300 w-full">
            <div className="w-fit flex flex-col">
              <div className="text-base font-semibold pt-4">
                <FormattedMessage {...messages.proview_assessment} />
              </div>
              <div className="text-base text-gray-600">
                <span>
                  <FormattedMessage {...messages.project_label} />
                </span>
                {COLON}
                <span className="pl-1">
                  <FormattedMessage {...messages.project_name} />
                </span>
              </div>
            </div>
            <div
              data-testid="close_btn"
              role="button"
              tabIndex={-1}
              className="px-2 text-gray-600 cursor-pointer"
              onClick={closePanel}
              onKeyPress={closePanel}
            >
              <XMarkIcon className="w-6 h-6" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
      <div className="sticky bottom-0">
        <div className="h-20 flex items-center justify-end px-6 bg-white shadow-[0px_3px_45px_0px_#00000024]">
          <Button onClick={saveExamDetails} className="w-20">
            <FormattedMessage {...messages.save} />
          </Button>
        </div>
      </div>
    </SidePanel>
  );
};

export default ExamDetails;
